import { IconButton, Slider, Tooltip } from "@mui/material";
import React, { useEffect, useMemo, useState } from "react";
import {
  Controller,
  FormProvider,
  useForm,
  useFormContext,
} from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { languageSelector } from "slices/languageSlice";
import { userSelector } from "slices/userSlice";
import { Select, selectCustomStyles } from "./common/Select";
import { fetchLanguages } from "slices/languageSlice";
import ErrorMessage from "./common/ErrorMessage";
import useFacilitiesFeatured from "hooks/useFacilitiesFeatured";
import moment from "moment";
import { SubmitButton } from "./common/buttons/SubmitButton";
import { fetchVendors } from "slices/vendorSlice";
import { setError } from "slices/scheduleSlice";
import Checkbox from "./common/Checkbox";
import { AsyncPaginate } from "react-select-async-paginate";
import Swal from "sweetalert2";
import { fetchTypes } from "slices/typeSlice";
import { fetchFacilities, fetchFacilitiesDirect } from "slices/facilitiesSlice";
import { fetchDepartments, fetchDepartmentsByFacility } from "slices/departmentsSlice";
import Api from "services/api";
import { fetchInterpreters } from "slices/interpreterSlice";
import { updateAppointment } from "slices/appointmentSlice";
import { addAppointment } from "slices/appointmentSlice";
import toast from "react-hot-toast";
import { fetchAppointments } from "slices/appointmentSlice";
import { useNavigate } from "react-router-dom";
import { appointmentsSelector } from "slices/appointmentSlice";
import { facilitiesSelector } from "slices/facilitiesSlice";
import { departmentsSelector } from "slices/departmentsSlice";
import { Spinner } from "reactstrap";
import { filterPatient } from "slices/appointmentSlice";
import { setDepartment } from "slices/departmentsSlice";
import { setFacilities } from "slices/facilitiesSlice";
import TagInput from "./TagInput";
import { fetchAppointmentView } from "slices/appointmentSlice";

//#region OPTIONS ARRAYS
export const businessDivisionOptions = [
  { value: "Castell", label: "Castell" },
  { value: "Intermountain", label: "Intermountain" },
  { value: "Medical Group", label: "Medical Group" },
  { value: "Tellica", label: "Tellica" },
];

export const priorityLevelOptions = [
  { value: "Regular", label: "Regular" },
  { value: "High", label: "Higher Priority" },
  { value: "Low", label: "Lower Priority" },
];

export const genderOptions = [
  { value: "Male", label: "Male" },
  { value: "Female", label: "Female" },
  { value: "Non-binary", label: "Non-binary" },
];

export const encounterTypeOptions = [
  { value: "In Person", label: "In Person" },
  { value: "VRI", label: "VRI" },
  { value: "OPI", label: "OPI" },
  { value: "OPI On Demand", label: "OPI On Demand" },
];

export const encounterSourceOptions = [
  { value: "Revenue Cycle", label: "Revenue Cycle" },
  { value: "Service Hub", label: "Service Hub" },
  { value: "Telephonic", label: "Telephonic" },
  { value: "Manual", label: "Manual" },
  { value: "List", label: "List" },
  { value: "Other", label: "Other" },
];

export const jobTypesOptions = [
  { value: "Assign", label: "Assign" },
  { value: "Escalation", label: "Escalation" },
  { value: "Open", label: "Open" },
];

export const statusOptions = [
  { value: "Billed", label: "Billed" },
  { value: "Dispute", label: "Dispute" },
  { value: "Paid", label: "Paid" },
];
//#endregion

const ScheduleForm = ({
  handleClose,
  item,
  afterUpdated,
  callBack,
  isDuplicate = false,
  itsBootstrap = true,
  isNew = false,
  append = false,
  values,
  show,
}) => {
  console.log("itemsss", item);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { language: languages, loadingLanguage } =
    useSelector(languageSelector);
  const { departments } = useSelector(departmentsSelector);
  const { user } = useSelector(userSelector);
  const methods = useForm({
    defaultValues: {
      priority_level: "Regular",
      gender: "",
      duration: 120,
      date: moment(new Date()).format("YYYY-MM-DD"),
      start_time: moment(new Date()),
      comments: "Other",
      type: encounterTypeOptions[1].value,
      other_language: "",
    },
  });
  const defaultLangauge = "Spanish";

  const {
    setFocus,
    handleSubmit,
    watch,
    formState: { errors },
    control,
    setValue,
    setError: setErrors,
    clearErrors,
    getValues,
  } = methods;
  const { error, appointments: scheduleLists } =
    useSelector(appointmentsSelector);
  const [loaderState, setLoaderState] = React.useState(false);
  const [mrnLoader, setMrnLoader] = React.useState(false);
  const [filterFacilities, setfilterFacilities] = useState(null);

  //#region  CLEAR UP ALL FIELDS
  const clearAllFields = React.useCallback(() => {
    setValue("account_id", "");
    setValue("interpreter_id", "");
    setValue("type", "VRI");
    setValue("date", moment(new Date()).format("YYYY-MM-DD"));
    setValue("start_time", moment().format("HH:mm"));
    setValue("language_id", "");
    setValue("duration", 120);
    setValue("vendor_id", "");
    setValue("requester_name", user?.user?.name || "");
    setValue("requester_phone", "");
    setValue("requester_email", user?.user?.email ? [user?.user?.email] : []);
    setValue("facility_id", "");
    setValue("address", "");
    setValue("department_id", "");
    setValue("patient_phone", "");
    setValue("special_instruction", "");
    setValue("encounter_source", "");
    setValue("priority_level", "Regular");
    setValue("gender", "");
    setValue("mrn_number", "");
    setValue("patient_name", "");
    setValue("birth_date", "");
    setValue("provider_name", "");
    setValue("medicaid_id", "");
    setValue("medicaid_plan", "");
    setValue("checkin_date", "");
    setValue("checkin_time", "");
    setValue("checkout_date", "");
    setValue("checkout_time", "");
    setValue("comments", "Other");
    setValue("notes", "");
    setValue("other_language", "");
    clearErrors();
    dispatch(setError({}));
  }, [setValue, clearErrors, dispatch, user]);

  useEffect(() => {
    dispatch(setDepartment([]));
  }, []);
  //#endregion

  //#region useEffects
  React.useEffect(() => {
    if (show === false) return;

    const birth_date = item?.appointment_details?.patient?.birth_date;

    setValue("language_id", item?.language_id || "");
    setValue("date", item?.date || moment(new Date()).format("YYYY-MM-DD"));
    setValue("start_time", item?.start_time || moment().format("HH:mm"));
    setValue("account_id", item?.account_id || "");

    setValue("facility_id", item?.appointment_details?.facility_id || "");
    setValue("department_id", item?.appointment_details?.department_id || "");
    const deptName = item?.appointment_details?.department?.department_name || item?.appointment_details?.department?.name || "";
    const deptId = item?.appointment_details?.department?.id || "";
    setFilterDepartments(deptId ? { label: deptName, value: deptId } : null);
    console.log(item?.appointment_details?.address, 'sdassadsdassaasdddasdsaasd')
    setValue("address", item?.appointment_details?.address || "");
    setValue("brief_description", item?.appointment_details?.breif_description || "");

    setValue(
      "special_instruction",
      item?.appointment_details?.special_instruction || ""
    );
    setValue("duration", item?.duration || 120);
    setValue(
      "priority_level",
      item?.appointment_details?.priority_level || "Regular"
    );
    setValue("gender", item?.appointment_details?.gender || "");

    setValue(
      "mrn_number",
      item?.appointment_details?.patient?.mrn_number || ""
    );
    setValue(
      "patient_name",
      item?.appointment_details?.patient?.patient_name || ""
    );
    console.log("birth_date", birth_date);
    setValue(
      "birth_date",
      birth_date ? moment(new Date(birth_date)).format("YYYY-MM-DD") || "" : ""
    );
    setValue(
      "medicaid_id",
      item?.appointment_details?.patient?.medicaid_id || ""
    );
    setValue(
      "medicaid_plan",
      item?.appointment_details?.patient?.medicaid_plan || ""
    );
    setValue("type", item?.appid ? item?.type : encounterTypeOptions[0].value);
    setValue(
      "encounter_source",
      item?.appointment_details?.encounter_source || ""
    );
    if (!item?.id && !isDuplicate) {
      setValue("requester_name", user?.user?.name || "");
      setValue("requester_email", user?.user?.email ? [user?.user?.email] : []);
    } else {
      setValue("requester_name", item?.appointment_details?.requester_name || "");
      setValue(
        "requester_email",
        item?.appointment_details?.requester_email || []
      );
    }
    setValue(
      "requester_phone",
      item?.appointment_details?.requester_phone || ""
    );
    setValue("interpreter_id", item?.interpreter_id || "");
    setValue("vendor_id", item?.vendor_id || "");
    setValue("provider_name", item?.appointment_details?.provider_name || "");

    setValue("checkin_date", item?.appointment_assign?.checkin_date || "");
    setValue("checkin_time", item?.appointment_assign?.checkin_time || "");
    setValue("checkout_date", item?.appointment_assign?.checkout_date || "");
    setValue("checkout_time", item?.appointment_assign?.checkout_time || "");
    setValue("comments", item?.appointment_assign?.comments || "Other");
    setValue("notes", item?.appointment_details?.notes || item?.appointment_assign?.notes || "");
    setValue("other_language", item?.other_language || "");
  }, [show, item?.id, item?.appid, setValue, dispatch, user, isDuplicate]);
  //#endregion

  //#region FETCH MRN NUMBER
  const fetchMRN = React.useCallback(() => {
    if (!watch("mrn_number")) {
      clearErrors("mrn_number");
      setValue("patient_name", "");
      setValue("birth_date", "");
      setValue("provider_name", "");
      setValue("medicaid_id", "");
      setValue("medicaid_plan", "");
      return;
    }
    clearErrors("mrn_number");
    const callback = (success, values) => {
      if (success) {
        setValue("patient_name", values?.patient_name);
        setValue("birth_date", values?.birth_date);
        setValue("provider_name", values?.provider_name);
        setValue("medicaid_id", values?.medicaid_id);
        setValue("medicaid_plan", values?.medicaid_plan);

        clearErrors("mrn_number");
        clearErrors("patient_name");
        clearErrors("birth_date");
        clearErrors("provider_name");
        clearErrors("medicaid_id");
        clearErrors("medicaid_plan");
      } else {
        setErrors("mrn_number", {
          message:
            "There is no Patient Available on this MRN, please create a new one",
        });
      }
    };
    dispatch(filterPatient({ mrn_number: watch("mrn_number") }, callback));
  }, [watch("mrn_number")]);
  //#endregion

  useEffect(() => {
    // setValue('facility_id', facilities?.find(i => i?.id === watch('facility_id'))?.id || '')
    // setValue('department_id', departments?.find(i => i?.id === watch('department_id'))?.id || '')
  }, [watch("facility_id"), watch("department_id")]);

  //#region SUBMIT FORM
  const submitCallback = (status, message, data) => {
    console.log("id", data?.id);
    if (status) {
      toast.success(message, {
        className: "successToast",
      });
      clearAllFields();
      handleClose();
      setLoaderState(false);
      Swal.fire({
        title: "Success!",
        text: message,
        icon: "success",
      }).then(() => {
        // alert("itemId", data?.id);
        dispatch(fetchAppointmentView(data?.id));
        navigate(`/appointments/view/${data?.id}`);
      });
      console.log("itemId", data?.id);

      console.log("after fetching view");
      // dispatch(fetchAppointments());
    } else {
      console.log("onSubmit", error);
      toast.error(message, {
        className: "errorToast",
      });
      setTimeout(() => {
        setLoaderState(false);
      }, 1000);
    }
  };

  const onSubmit = React.useCallback(
    (data) => {
      dispatch(setError({}));
      setLoaderState(true);

      // Fix requester_email to be always an array
      if (typeof data.requester_email === "string") {
        try {
          data.requester_email = JSON.parse(data.requester_email);
          if (!Array.isArray(data.requester_email)) {
            data.requester_email = [];
          }
        } catch {
          data.requester_email = data.requester_email
            ? data.requester_email.split(",").map((email) => email.trim())
            : [];
        }
      }

      // Your rest of validations and submission
      if (data?.interpreter_id) {
        if (data?.checkin_date && !data?.checkin_time) {
          setErrors("checkin_time", { message: "Please select checkin time" });
          return;
        }
        if (data?.checkout_date && !data?.checkout_time) {
          setErrors("checkout_time", {
            message: "Please select checkout time",
          });
          return;
        }
      }
      if (item?.id && !isDuplicate) {
        dispatch(updateAppointment(data, item?.id, submitCallback, true));
      } else {
        dispatch(addAppointment(data, submitCallback, true));
      }
    },
    [item, callBack, append, isNew, isDuplicate, values, watch("date")]
  );

  const scrollToError = (fieldName) => {
    const element = document.querySelector(`[name="${fieldName}"]`);
    if (element) {
      const parentContainer = document.querySelector("#scheduleEncounter"); // Replace with your container class
      if (parentContainer) {
        const offsetTop = element.offsetTop - parentContainer.offsetTop;
        parentContainer.scrollTo({
          top: offsetTop,
          behavior: "smooth",
        });
      }
      // element.scrollIntoView({ behavior: "smooth", block: "center" });
      setFocus(fieldName); // Focus the field
    }
  };

  const onError = (error) => {
    const firstErrorField = Object.keys(error)[0];
    if (firstErrorField) scrollToError(firstErrorField);
  };

  //#endregion

  const account_id = watch("account_id");

  const handleFacDepChange = () => {
    setfilterFacilities({});
    setFilterDepartments(null);
    setValue("facility_id", null);
    setValue("department_id", null);
  };

  // useEffect(() => {
  //   setValue(
  //     "address",
  //     facilities?.find((i) => i?.id === watch("facility_id"))?.address
  //   );
  // }, [facilities, watch("facility_id"), setValue]);

  const isVendor = useMemo(() => {
    return watch("vendor_id") ? true : false;
  }, [watch("vendor_id")]);

  const isInterpreter = useMemo(() => {
    return watch("interpreter_id") ? true : false;
  }, [watch("interpreter_id")]);

  // #region language dropdown
  const [filterLanguages, setfilterLanguages] = useState({
    label: "",
    value: "",
  });

  useEffect(() => {
    if (item?.language?.name && item?.language?.id) {
      setfilterLanguages({
        label: item?.language?.name || "",
        value: item?.language?.id || "",
      });
      setValue("language_id", item?.language?.id);
      setValue("other_language", "");
    } else if (item?.other_language) {
      setfilterLanguages(null);
      setValue("language_id", null);
      setValue("other_language", item?.other_language);
    } else if (!item?.id && !isDuplicate) {
      const fetchData = async () => {
        try {
          const result = await dispatch(
            fetchLanguages(1, { search: defaultLangauge }, true, true)
          );
          const defaultLang = result?.data[0];
          setValue("language_id", defaultLang?.id);
          setfilterLanguages({
            label: defaultLang?.name,
            value: defaultLang?.id,
          });
        } catch (err) {
          console.error("Error fetching languages:", err);
        }
      };

      fetchData();
    }
  }, [item?.language, item?.other_language, item?.id, isDuplicate, defaultLangauge]);

  // #region client dropdown
  const [filterClients, setfilterClients] = useState({
    label: "",
    value: "",
  });

  // useEffect(() => {
  //   setfilterFacilities({});

  //   if (!filterClients.value) dispatch(setFacilities([]));
  //   dispatch(setDepartment([]));
  // }, [filterClients]);

  const filteredLanguageLoadOptions = React.useCallback(async (
    inputValue,
    loadedOptions,
    { page }
  ) => {
    const result = await dispatch(
      fetchLanguages(
        page,
        {
          pageLength: 20,
          sortBy: "id",
          sortDirection: "asc",
          search: inputValue,
        },
        true,
        true
      )
    );

    let options = result?.data?.map((val) => ({
      value: val.id,
      label: val.name,
    })) || [];

    return {
      options: options,

      hasMore: page < Number(result?.last_page),
      additional: {
        page: page + 1,
      },
    };
  }, [dispatch]);

  //#endregion

  // facilities = filterClients && filterClients.label === "" && filterClients.value === "" ? [] : facilities;

  useEffect(() => {
    if (item?.accounts?.user?.name && item?.accounts?.user?.id) {
      setfilterClients({
        label: item?.accounts?.user?.name || "",
        value: item?.accounts?.user?.id || "",
      });
    } else {
      setfilterClients({
        label: "",
        value: "",
      });
    }
  }, [item?.accounts?.user]);

  const filteredClientsLoadOptions = React.useCallback(async (
    inputValue,
    loadedOptions,
    { page }
  ) => {
    const result = await dispatch(
      fetchTypes(
        page,
        {
          pageLength: 20,
          sortBy: "id",
          sortDirection: "asc",
          search: inputValue,
        },
        true,
        true
      )
    );
    return {
      options: result?.data?.map((val) => ({
        value: val.id,
        label: val.name,
      })) || [],

      hasMore: page < Number(result?.last_page),
      additional: {
        page: page + 1,
      },
    };
  }, [dispatch]);

  const filteredFacilitiesLoadOptions = React.useCallback(async (
    inputValue,
    loadedOptions,
    { page }
  ) => {
    const result = await dispatch(
      fetchFacilities(
        page,
        {
          pageLength: 20,
          sortBy: "name",
          sortDirection: "asc",
          search: inputValue,
        },
        true,
        true
      )
    );
    return {
      options: result?.data?.map((val) => ({
        value: val.id,
        label: val.facility_name || val.abbreviation || val.name || val.label,
      })) || [],

      hasMore: page < Number(result?.last_page),
      additional: {
        page: page + 1,
      },
    };
  }, [dispatch]);
  //#endregion



  const [filterDepartments, setFilterDepartments] = useState(null);

  useEffect(() => {
    if (item?.department?.name && item?.department?.id) {
      setFilterDepartments({
        label: item?.department?.department_name || "",
        value: item?.department?.id || "",
      });
    }
  }, [item?.department]);

  const filteredDepartmentsLoadOptions = React.useCallback(async (
    inputValue,
    loadedOptions,
    { page }
  ) => {
    const result = await dispatch(
      fetchDepartments(
        page,
        {
          facility_id: 1,
          pageLength: 20,
          sortBy: "name",
          sortDirection: "asc",
          search: inputValue,
        },
        true,
        true
      )
    );
    return {
      options: result?.data
        ?.filter((val) => val.name || val.department_name)
        .map((val) => ({
          value: val.id,
          label: val.name || val.department_name || "",
          ...val
        })) || [],

      hasMore: page < Number(result?.last_page),
      additional: {
        page: page + 1,
      },
    };
  }, [dispatch]);

  //#endregion

  // #region vendordropdown
  const [filterVendor, setFilterVendors] = useState({
    label: "",
    value: "",
  });

  useEffect(() => {
    if (item?.vendor?.name && item?.vendor?.id) {
      setFilterVendors({
        label: item?.vendor?.name || "",
        value: item?.vendor?.id || "",
      });
    } else {
      setFilterVendors(null);
    }
  }, [item?.vendor]);

  const filteredVendorLoadOptions = React.useCallback(async (
    inputValue,
    loadedOptions,
    { page }
  ) => {
    const result = await dispatch(
      fetchVendors(
        page,
        {
          pageLength: 20,
          sortBy: "id",
          sortDirection: "asc",
          search: inputValue,
        },
        true,
        true
      )
    );
    return {
      options: result?.data?.map((val) => ({
        value: val.id,
        label: val.name,
      })) || [],

      hasMore: page < Number(result?.last_page),
      additional: {
        page: page + 1,
      },
    };
  }, [dispatch]);
  //#endregion

  // #region Interpreter Dropdown
  const [filterInterpreters, setFilterInterpreters] = useState({
    label: "",
    value: "",
  });

  useEffect(() => {
    if (item?.interpreter?.first_name && item?.interpreter?.id) {
      setFilterInterpreters({
        label: item?.interpreter?.first_name || "",
        value: item?.interpreter?.id || "",
      });
    } else {
      setFilterInterpreters(null);
    }
  }, [item?.interpreter]);

  const filteredInterpretersLoadOptions = React.useCallback(async (
    inputValue,
    loadedOptions,
    { page }
  ) => {
    const result = await dispatch(
      fetchInterpreters(
        page,
        {
          pageLength: 20,
          sortBy: "id",
          sortDirection: "asc",
          search: inputValue,
        },
        true,
        true
      )
    );
    return {
      options: result?.data?.map((val) => ({
        value: val.id,
        label: val.first_name,
      })) || [],

      hasMore: page < Number(result?.last_page),
      additional: {
        page: page + 1,
      },
    };
  }, [dispatch]);
  //#endregion

  return (
    <FormProvider {...methods}>
      <form>
        {/* INPUTS */}
        <>
          {/* LANGUAGE SELECT */}
          <div className="row-primary">
            <h2>Language *</h2>
            <div className="w-100">
              <Controller
                name="language_id"
                control={control}
                rules={{
                  validate: (value) =>
                    (value || watch("other_language")) ? true : "Please select a language",
                }}
                render={({ field }) => (
                  <div style={{ width: "100%" }}>
                    <AsyncPaginate
                      menuPlacement="auto"
                      styles={{
                        ...selectCustomStyles,
                      }}
                      debounceTimeout={300}
                      value={filterLanguages}
                      loadOptions={filteredLanguageLoadOptions}
                      isClearable
                      escapeClearsValue
                      onChange={(obj) => {
                        setfilterLanguages(obj);
                        field.onChange(obj?.value || null);
                        if (obj?.value) {
                          setValue("other_language", ""); // Clear other language if a language is selected
                          clearErrors("other_language");
                        }
                      }}
                      additional={{
                        page: item?.state?.id ? 2 : 1,
                      }}
                    />
                    {errors?.language_id?.message && (
                      <div style={{ marginBottom: 10 }}>
                        <ErrorMessage text={errors?.language_id?.message} />
                      </div>
                    )}
                  </div>
                )}
              />
            </div>
          </div>

          <div className="row-primary">
            <h2>Other Language</h2>
            <div className="w-100">
              <Controller
                name="other_language"
                control={control}
                rules={{
                  validate: (value) =>
                    (value || watch("language_id")) ? true : "Please enter other language",
                }}
                render={({ field }) => (
                  <div style={{ width: "100%" }}>
                    <input
                      {...field}
                      type="text"
                      className="input-in type_inp"
                      placeholder="Enter other language"
                      disabled={!!watch("language_id")}
                      onChange={(e) => {
                        field.onChange(e);
                        if (e.target.value) {
                          setValue("language_id", null);
                          setfilterLanguages(null);
                          clearErrors("language_id");
                        }
                      }}
                    />
                    {errors?.other_language?.message && (
                      <div style={{ marginBottom: 10 }}>
                        <ErrorMessage text={errors?.other_language?.message} />
                      </div>
                    )}
                  </div>
                )}
              />
            </div>
          </div>

          {/* DATE TIME INPUT */}
          <DateTimeInputs isDuplicate={isDuplicate} isNew={isNew} />

          {/* Client SELECT */}
          {/* <div className="row-primary">
            <h2>Client *</h2>
            <div className="w-100">
              <Controller
                name="account_id"
                control={control}
                rules={{
                  required: "Please select a client",
                }}
                render={({ field }) => (
                  <div style={{ width: "100%" }}>
                    <AsyncPaginate
                      menuPlacement="auto"
                      styles={{
                        ...selectCustomStyles,
                      }}
                      value={filterClients}
                      loadOptions={filteredClientsLoadOptions}
                      isClearable
                      escapeClearsValue
                      onChange={(obj) => {
                        if (obj?.value) {
                          setfilterClients(obj);
                          field.onChange(obj.value);
                          handleFacDepChange();
                          // dispatch(setDepartment())
                          dispatch(
                            fetchFacilities(1, {
                              user_id: obj.value,
                              pageLength: 1000,
                              sortBy: "id",
                              sortDirection: "asc",
                            })
                          );
                          // dispatch(fetchDepartments(1, { user_id: obj.value, pageLength: 1000, sortBy: "id", sortDirection: "asc" }));
                        } else {
                          handleFacDepChange();
                          setfilterClients({
                            label: "",
                            value: "",
                          });
                          setfilterFacilities({});
                          window.localStorage.removeItem("facilities");
                          field.onChange(null);
                          console.log("Client unselected");
                        }
                      }}
                      additional={{
                        page: item?.state?.id ? 2 : 1,
                      }}
                    />
                    {errors?.account_id?.message && (
                      <div style={{ marginBottom: 10 }}>
                        <ErrorMessage text={errors?.account_id?.message} />
                      </div>
                    )}
                  </div>
                )}
              />
            </div>
          </div> */}

          {/* DEPARTMENT SELECT */}
          <div className="row-primary">
            <h2>Department Name&#8209;*</h2>
            <div className="w-100">
              <Controller
                name="department_id"
                control={control}
                rules={{
                  required: "Please select a department",
                }}
                render={({ field }) => (
                  <div style={{ width: "100%" }}>
                    <AsyncPaginate
                      menuPlacement="auto"
                      styles={{ ...selectCustomStyles }}
                      debounceTimeout={300}
                      value={filterDepartments}
                      loadOptions={filteredDepartmentsLoadOptions}
                      isClearable
                      onChange={(obj) => {
                        if (obj) {
                          field.onChange(obj.value);
                          setFilterDepartments(obj);
                          setValue("address", obj.address || "");
                        } else {
                          setFilterDepartments(null);
                          field.onChange(null);
                        }
                      }}
                      additional={{ page: 1 }}
                    />
                    {errors?.department_id?.message && (
                      <div style={{ marginBottom: 10 }}>
                        <ErrorMessage text={errors?.department_id?.message} />
                      </div>
                    )}
                  </div>
                )}
              />
            </div>
          </div>

          {/* FACILITY ADDRESS */}
          <div className="row-primary">
            <h2>Address</h2>
            <Controller
              name="address"
              control={control}
              render={({ field }) => (
                <input
                  className="input-in type_inp"
                  type="text"
                  name="address"
                  placeholder="Facility Address"
                  {...field}
                />
              )}
            />
          </div>


          {/* DURATION */}
          <DurationRange control={control} />

          {/* Priority Level */}
          {/* <PriorityLevel control={control} errors={errors} /> */}

          {/* MRN NUMBER */}
          <div className="row-primary">
            <h2>MRN Number *</h2>

            <Controller
              name="mrn_number"
              control={control}
              rules={{
                required: "MRN number is required",
              }}
              disabled={mrnLoader}
              render={({ field }) => (
                <div style={{ width: "100%" }}>
                  <div className="input-image">
                    <input
                      id="mrn_number"
                      type="text"
                      name="mrn_number"
                      // className="input-in type_inp"
                      placeholder="MRN Number"
                      {...field}
                      disabled={mrnLoader}
                    />

                    <Tooltip title="Click to get Patient Details">
                      <IconButton
                        type="button"
                        aria-label="delete"
                        disabled={!watch("mrn_number") || mrnLoader}
                        onClick={fetchMRN}
                      >
                        {mrnLoader ? (
                          <Spinner size={"sm"} color="primary" type="grow" />
                        ) : (
                          <h2
                            style={{
                              color: "#777682",
                              minWidth: "auto",
                              marginTop: 0,
                            }}
                            onPress={fetchMRN}
                          >
                            Fetch
                          </h2>
                        )}
                      </IconButton>
                    </Tooltip>
                  </div>
                  {errors?.mrn_number?.message && (
                    <div style={{ marginBottom: 10 }}>
                      <ErrorMessage text={errors?.mrn_number?.message} />
                    </div>
                  )}
                </div>
              )}
            />
          </div>

          {/* PATIENT NAME */}
          <div className="row-primary">
            <h2>Patient Name *</h2>
            <Controller
              name="patient_name"
              control={control}
              rules={{
                required: "Patient name is required",
              }}
              render={({ field }) => (
                <div style={{ width: "100%" }}>
                  <input className="input-in type_inp" type="text" {...field} />

                  {errors?.patient_name?.message && (
                    <div style={{ marginBottom: 10 }}>
                      <ErrorMessage text={errors?.patient_name?.message} />
                    </div>
                  )}
                </div>
              )}
            />
          </div>

          {/* BIRTH DATE */}
          <div className="row-primary">
            <h2>Birth Date *</h2>
            <Controller
              name="birth_date"
              control={control}
              rules={{
                required: "Birth date is required",
              }}
              render={({ field }) => (
                <div style={{ width: "100%" }}>
                  <div className="input-image">
                    <input
                      id="birth_date"
                      type="date"
                      name="birth_date"
                      placeholder="YYYY-MM-DD"
                      {...field}
                      value={field.value ? field?.value : ""}
                      onPaste={(e) => {
                        e.preventDefault(); // Prevent default paste behavior
                        const pastedData = e.clipboardData.getData("text"); // Get pasted text
                        const dateString = moment
                          .utc(pastedData)
                          .format("YYYY-MM-DD");

                        if (moment(dateString, "YYYY-MM-DD", true).isValid()) {
                          field.onChange(dateString);
                        } else {
                          console.warn("Invalid date format");
                        }
                      }}
                      onChange={(e) => {
                        const dateString = moment
                          .utc(e.target.value)
                          .format("YYYY-MM-DD");
                        field.onChange(dateString);
                      }}
                    />
                    <img
                      src="/images/celender.png"
                      alt="celender Icon"
                      className="custom-icon"
                    />
                  </div>
                  {errors?.birth_date?.message && (
                    <div style={{ marginBottom: 10 }}>
                      <ErrorMessage text={errors?.birth_date?.message} />
                    </div>
                  )}
                </div>
              )}
            />
          </div>

          {/* MEDICAID ID */}
          {/* <div className="row-primary">
            <h2>Medicaid ID#</h2>
            <Controller
              name="medicaid_id"
              control={control}
              render={({ field }) => (
                <div style={{ width: "100%" }}>
                  <input className="input-in type_inp" type="text" {...field} />
                  {errors?.medicaid_id?.message && (
                    <div style={{ marginBottom: 10 }}>
                      <ErrorMessage text={errors?.medicaid_id?.message} />
                    </div>
                  )}
                </div>
              )}
            />
          </div> */}

          {/* MEDICAID PLAN */}
          {/* <div className="row-primary">
            <h2>Medicaid Plan</h2>
            <Controller
              name="medicaid_plan"
              control={control}
              render={({ field }) => (
                <div style={{ width: "100%" }}>
                  <input className="input-in type_inp" type="text" {...field} />
                  {errors?.medicaid_plan?.message && (
                    <div style={{ marginBottom: 10 }}>
                      <ErrorMessage text={errors?.medicaid_plan?.message} />
                    </div>
                  )}
                </div>
              )}
            />
          </div> */}

          {/* ENCOUNTER TYPE */}
          {/* <div className="row-primary">
            <h2>Encounter Type *</h2>
            <Controller
              name="type"
              control={control}
              rules={{
                required: "Encounter type is required",
              }}
              render={({ field }) => (
                <div style={{ width: "100%" }}>
                  <Select
                    name="type"
                    options={encounterTypeOptions || []}
                    {...field}
                    value={
                      field.value
                        ? encounterTypeOptions?.find(
                          (opt) => opt.value == field.value
                        )
                        : ""
                    }
                    isClearable={false}
                  />

                  {errors?.type?.message && (
                    <div style={{ marginBottom: 10 }}>
                      <ErrorMessage text={errors?.type?.message} />
                    </div>
                  )}

                  {error?.errors?.type?.map((error) => (
                    <div style={{ marginBottom: 10 }}>
                      <ErrorMessage text={error} />
                    </div>
                  ))}
                </div>
              )}
            />
          </div> */}

          {/* ENCOUNTER SOURCE */}
          {/* <div className="row-primary">
            <h2>Encounter Source</h2>
            <Controller
              name="encounter_source"
              control={control}
              render={({ field }) => (
                <div style={{ width: "100%" }}>
                  <Select
                    name="encounter_source"
                    options={encounterSourceOptions || []}
                    {...field}
                    loading={loadingLanguage}
                    value={
                      field.value
                        ? encounterSourceOptions?.find(
                          (opt) => field.value == opt.value
                        )
                        : ""
                    }
                  />
                  {errors?.encounter_source?.message && (
                    <div style={{ marginBottom: 10 }}>
                      <ErrorMessage text={errors?.encounter_source?.message} />
                    </div>
                  )}
                  {error?.errors?.encounter_source?.map((error) => (
                    <div style={{ marginBottom: 10 }}>
                      <ErrorMessage text={error} />
                    </div>
                  ))}
                </div>
              )}
            />
          </div> */}

          {/* REQUESTER */}
          <div className="row-primary">
            <h2>Requestor Name *</h2>
            <div className="w-100">
              <Controller
                name="requester_name"
                rules={{
                  required: "Requestor name is required",
                }}
                control={control}
                render={({ field }) => (
                  <input className="input-in type_inp" type="text" {...field} />
                )}
              />
              {errors?.requester_name?.message && (
                <div style={{ marginBottom: 10 }}>
                  <ErrorMessage text={errors?.requester_name?.message} />
                </div>
              )}
            </div>
          </div>

          {/* REQUESTOR EMAIL */}
          <div className="row-primary">
            <h2>Requestor Email</h2>
            <div className="w-100">
              <Controller
                name="requester_email"
                control={control}
                render={({ field }) => {
                  let emailsArray = [];

                  if (typeof field.value === "string") {
                    emailsArray = field.value
                      .split(",")
                      .map((email) => email.trim())
                      .filter((email) => email.length > 0);
                  } else if (Array.isArray(field.value)) {
                    emailsArray = field.value;
                  }

                  return (
                    <div>
                      <TagInput
                        value={emailsArray}
                        onChange={(newTags) => {
                          const newEmailsString = newTags.join(", ");
                          field.onChange(newEmailsString);
                        }}
                        validate={(email) => {
                          const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                          return emailRegex.test(email)
                            ? ""
                            : "Please enter a valid email address";
                        }}
                      />
                    </div>
                  );
                }}
              />

              {errors?.requester_email?.message && (
                <div style={{ marginBottom: 10 }}>
                  <ErrorMessage text={errors?.requester_email?.message} />
                </div>
              )}
            </div>
          </div>

          {/* REQUESTOR PHONE NUMBER */}
          <div className="row-primary">
            <h2>Requestor Phone Number</h2>
            <div className="w-100">
              <Controller
                name="requester_phone"
                control={control}
                render={({ field }) => (
                  <input
                    className="input-in type_inp"
                    type="tel"
                    name="requester_phone"
                    placeholder="Phone Number"
                    {...field}
                    onChange={(e) => {
                      if (e.target.value.length <= 20) {
                        field.onChange(e);
                      }
                    }}
                  />
                )}
              />

              {error?.errors?.phone?.map((error) => (
                <div style={{ marginBottom: 10 }}>
                  <ErrorMessage text={error} />
                </div>
              ))}
            </div>
          </div>


          {/* PROVIDER NAME */}
          <div className="row-primary">
            <h2>Provider Name</h2>
            <div className="w-100">
              <Controller
                name="provider_name"
                control={control}
                render={({ field }) => (
                  <input className="input-in type_inp" type="text" {...field} />
                )}
              />
            </div>
          </div>

          {/* GENDER */}
          <div className="row-primary">
            <h2>Gender</h2>
            <div className="w-100">
              <Controller
                name="gender"
                control={control}
                render={({ field }) => (
                  <Select
                    name="gender"
                    options={genderOptions || []}
                    {...field}
                    value={
                      field.value
                        ? genderOptions?.find((opt) => opt.value == field.value)
                        : ""
                    }
                  />
                )}
              />
            </div>
          </div>

          {/* VENDOR SELECT */}
          {(!item?.id || isDuplicate) && (
            <div className="row-primary">
              <h2>Vendor</h2>
              <div className="w-100">
                <Controller
                  name="vendor_id"
                  control={control}
                  render={({ field }) => (
                    <div style={{ width: "100%" }}>
                      <AsyncPaginate
                        menuPlacement="auto"
                        styles={{
                          ...selectCustomStyles,
                        }}
                        debounceTimeout={300}
                        isDisabled={isInterpreter} // Keep this for UI behavior
                        value={filterVendor}
                        loadOptions={filteredVendorLoadOptions}
                        isClearable
                        escapeClearsValue
                        onChange={(obj) => {
                          if (obj?.value) {
                            setFilterVendors(obj);
                            field.onChange(obj.value);
                          } else {
                            setFilterVendors(null);
                            field.onChange(null);
                          }
                        }}
                        additional={{
                          page: item?.state?.id ? 2 : 1,
                        }}
                      />
                      <p style={{ fontSize: 12, color: "#6b7280", marginTop: 4 }}>
                        Leave blank for urgent requests or hard to fill languages (ASL, Micronesian languages, etc) to send to all vendors
                      </p>
                    </div>
                  )}
                />
              </div>
            </div>
          )}

          {/* INTERPRETER SELECT */}
          {/* {(!item?.id || isDuplicate) && (
            <div className="row-primary">
              <h2>Interpreter</h2>
              <div className="w-100">
                <Controller
                  name="interpreter_id"
                  control={control}
                  render={({ field }) => (
                    <div style={{ width: "100%" }}>
                         <AsyncPaginate
                           menuPlacement="top"
                           styles={{
                             ...selectCustomStyles,
                           }}
                           debounceTimeout={300}
                           isDisabled={isVendor}
                           value={filterInterpreters}
                           loadOptions={filteredInterpretersLoadOptions}
                           isClearable
                           escapeClearsValue
                           onChange={(obj) => {
                             if (obj?.value) {
                               setFilterInterpreters(obj);
                               field.onChange(obj.value);
                             } else {
                               setFilterInterpreters(null);
                               field.onChange(null);
                             }
                           }}
                           additional={{
                             page: item?.state?.id ? 2 : 1,
                           }}
                         />
                    </div>
                  )}
                />
              </div>
            </div>
          )} */}

          {watch("interpreter_id") && (
            <CheckinCheckout apptAssign={item?.appointment_assign} />
          )}
          {watch("available_status") &&
            watch("interpreter_id") &&
            item?.appointment_assign?.interpreter_id && (
              <>
                <CheckinDateTimeInputs />
                <CheckoutDateTimeInputs />
                <CommentsAndNotes />
              </>
            )}
        </>

        {/* SPECIAL INSTRUCTIONS */}
        <div className="row-primary">
          <h2>Special Instruction</h2>
          <Controller
            name="special_instruction"
            control={control}
            render={({ field }) => (
              <textarea
                className="type_inp input-in"
                {...field}
                placeholder="Special Instructions"
                required
              ></textarea>
            )}
          />
        </div>


        {/* SPECIAL INSTRUCTIONS */}
        <div className="row-primary">
          <h2>Brief Description</h2>
          <Controller
            name="brief_description"
            control={control}
            render={({ field }) => (
              <textarea
                className="type_inp input-in"
                {...field}
                placeholder="Brief Description"
                required
              ></textarea>
            )}
          />
        </div>


        {/* NOTES */}
        <div className="row-primary">
          <h2>Notes</h2>
          <Controller
            name="notes"
            control={control}
            render={({ field }) => (
              <textarea
                className="type_inp input-in"
                {...field}
                placeholder="Notes"
                required
              ></textarea>
            )}
          />
        </div>

        {/* ERROR MESSAGES */}
        <>
          {Object.keys(errors)?.length > 0 && (
            <div className="row-primary align-center">
              <i class="fa-solid fa-circle-exclamation mt-2 error-color "></i>
              <ErrorMessage
                fontWeight={"bold"}
                text={"Please fill all mandatory fields"}
              />
            </div>
          )}

          {error?.errors?.billed?.map((error) => (
            <div style={{ marginBottom: 10 }}>
              <ErrorMessage text={error} />
            </div>
          ))}
          {error?.errors?.mrn_number?.map((error) => (
            <div style={{ marginBottom: 10 }}>
              <ErrorMessage text={error} />
            </div>
          ))}
          {error?.errors?.requestor_phone_num?.map((error) => (
            <div style={{ marginBottom: 10 }}>
              <ErrorMessage text={error} />
            </div>
          ))}
        </>

        <div className="Form-footer">
          <button
            type="button"
            className="Cancle_button"
            data-bs-dismiss={itsBootstrap ? "modal" : ""}
            onClick={handleClose}
          >
            Cancel
          </button>
          <SubmitButton
            btnText={item?.id && !isDuplicate ? "Update Request" : "Submit Request"}
            buttonType="button"
            handleSubmit={handleSubmit(onSubmit, onError)}
            loader={loaderState}
          />
        </div>
      </form>
    </FormProvider>
  );
};

export const CheckinCheckout = ({ apptAssign }) => {
  const { control, setValue, watch } = useFormContext();

  const interpreterId = watch("interpreter_id");

  useEffect(() => {
    if (interpreterId) {
      setValue(
        "comments",
        commentsTypeOptions[commentsTypeOptions?.length - 1].value
      );
    } else {
      setValue("comments", "");
    }
  }, [interpreterId]);

  useEffect(() => {
    if (apptAssign?.checkin_date) {
      setValue("available_status", true);
    }
  }, []);
  return (
    <>
      <div className="row-primary">
        {/* <h2>Add Check In / Check Out</h2> */}
        {/* <Controller
          name="available_status"
          control={control}
          render={({ field }) => (
            <Checkbox
              title={"Add Check In / Check Out"}
              isChecked={!!apptAssign?.checkin_date && field?.value}
              handleCheck={field.onChange}
              value={field.value}
            />
          )}
        /> */}
      </div>
    </>
  );
};

const DateTimeInputs = ({ isDuplicate, isNew }) => {
  const { control, formState, setValue, watch } = useFormContext();
  return (
    <div className="row-primary row-r">
      <div className="date">
        <h2>Date*</h2>
        <Controller
          name="date"
          control={control}
          rules={{
            required: "Please select date",
          }}
          render={({ field }) => (
            <div>
              <div className="input-image">
                <input
                  id="date"
                  type="date"
                  name="date"
                  placeholder="Date"
                  required
                  {...field}
                  value={field.value ? field.value : ""}
                  onChange={(e) => {
                    const dateString = e.target.value
                      ? moment.utc(e.target.value).format("YYYY-MM-DD")
                      : "";
                    field.onChange(dateString);

                    if (watch("available_status")) {
                      if (isDuplicate || isNew) {
                        setValue("checkin_date", watch("date"));
                        setValue("checkout_date", watch("date"));
                      }
                    }
                  }}
                />
                <img
                  src="/images/celender.png"
                  alt="celender Icon"
                  className="custom-icon"
                />
              </div>
              {formState?.errors?.date?.message && (
                <div style={{ marginBottom: 10 }}>
                  <ErrorMessage text={formState?.errors?.date?.message} />
                </div>
              )}
            </div>
          )}
        />
      </div>

      <div className="time">
        <h2>Time*</h2>
        <Controller
          name="start_time"
          control={control}
          rules={{
            required: "Please select start time",
          }}
          render={({ field }) => (
            <div>
              <div className="input-image">
                <input
                  type="time"
                  name="start_time"
                  placeholder="hh:mm"
                  {...field}
                  value={moment(field.value, ["h:mm A"]).format("HH:mm")}
                  onChange={(e) => {
                    // const timeString = moment.utc(e.target.value, ["HH:mm"]).format("HH:mm");
                    field.onChange(e.target.value);
                    if (watch("available_status")) {
                      if (isDuplicate || isNew) {
                        setValue("checkin_time", watch("start_time"));
                        // and checkout_time shoudld be 15 mins above start_time
                        const duraton = watch("duration");
                        const checkout_time = moment(e.target.value, ["HH:mm"])
                          .add(duraton, "minutes")
                          .format("HH:mm");
                        setValue("checkout_time", checkout_time);
                        // and checkout_date should be same as date
                      }
                    }
                  }}
                  // value={field.value}
                  required
                />
                <img
                  src="/images/clock.png"
                  alt="Clock Icon"
                  className="custom-icon"
                />
              </div>
              {formState?.errors?.start_time?.message && (
                <div style={{ marginBottom: 10 }}>
                  <ErrorMessage text={formState?.errors?.start_time?.message} />
                </div>
              )}
              <p style={{ fontSize: 12, color: "#6b7280", marginTop: 4 }}>
                Enter check-in time, not just the appointment/procedural start time
              </p>
            </div>
          )}
        />
      </div>
    </div>
  );
};

const commentsTypeOptions = [
  { value: "Admission/Intake", label: "Admission/Intake" },
  { value: "Discharge", label: "Discharge" },
  { value: "Informed Consent", label: "Informed Consent" },
  { value: "Service Decline", label: "Service Decline" },
  { value: "Other", label: "Other" },
];

export const CheckinDateTimeInputs = () => {
  const {
    control,
    setValue,
    watch,
    formState: { errors },
    setError,
    clearErrors,
  } = useFormContext();
  const [dateChecked, setDateChecked] = useState(false);
  const [timeChecked, setTimeChecked] = useState(false);
  const [checkinTimeRequired, setCheckinTimeRequired] = useState(false);

  useEffect(() => {
    if (watch("checkin_date") && !watch("checkin_time")) {
      setError("checkin_time", {
        message: "Checkin time required",
      });
    } else {
      clearErrors("checkin_time");
    }
  }, [watch("checkin_date"), watch("checkin_time")]);

  return (
    <div className="row-primary flex-column gap-0 mb-0">
      <h2 className="fst-italic">Add Check In</h2>
      <div className="row-primary row-r">
        <div className="date">
          <h2>Date*</h2>
          <Controller
            name="checkin_date"
            control={control}
            render={({ field }) => (
              <div style={{ width: "100%" }}>
                <div className="input-image">
                  <input
                    id="date"
                    type="date"
                    name="checkin_date"
                    placeholder="Date"
                    required
                    {...field}
                    value={
                      field.value
                        ? moment(field.value).format("YYYY-MM-DD")
                        : ""
                    }
                    onChange={(e) => {
                      const dateString = e.target.value
                        ? moment.utc(e.target.value).format("YYYY-MM-DD")
                        : "";

                      field.onChange(dateString);
                      if (!dateString) {
                        setValue("checkin_time", "");
                      }
                    }}
                  />
                  <img
                    src="/images/celender.png"
                    alt="celender Icon"
                    className="custom-icon"
                  />
                </div>
                {/* <div className="mt-2 sub_check">
                  <Checkbox
                    title={"Set Current Date"}
                    handleCheck={
                      (e) => {
                        if (e.target.checked) {
                          const currentDate = moment().format('YYYY-MM-DD')
                          setValue("checkin_date", currentDate)
                        }
                        else {
                          setValue("checkin_date", "")
                        }
                      }
                    }
                  />
                </div> */}
              </div>
            )}
          />
        </div>

        <div className="time">
          <h2>Time*</h2>
          <Controller
            name="checkin_time"
            control={control}
            render={({ field }) => (
              <div style={{ width: "100%" }}>
                <div className="input-image">
                  <input
                    type="time"
                    name="checkin_time"
                    placeholder="hh:mm"
                    {...field}
                    // value={moment(field.value, ["h:mm A"]).format("HH:mm")}
                    // value={field.value}
                    required
                  />
                  <img
                    src="/images/clock.png"
                    alt="Clock Icon"
                    className="custom-icon"
                  />
                </div>

                {errors?.checkin_time?.message && (
                  <div style={{ marginBottom: 10 }}>
                    <ErrorMessage text={errors?.checkin_time?.message} />
                  </div>
                )}
                {/* <div className="mt-2 sub_check">
                  <Checkbox
                    title={"Set Current Time"}
                    handleCheck={
                      (e) => {
                        if (e.target.checked) {
                          const currentTime = moment().format('HH:mm')
                          setValue("checkin_time", currentTime)
                        }
                        else {
                          setValue("checkin_time", "")
                        }
                      }
                    }
                  />
                </div> */}
              </div>
            )}
          />
        </div>
      </div>
    </div>
  );
};

export const CheckoutDateTimeInputs = () => {
  const {
    control,
    setValue,
    watch,
    formState: { errors },
    setError,
    clearErrors,
  } = useFormContext();
  const [checkoutTimeRequired, setCheckoutTimeRequired] = useState(false);

  useEffect(() => {
    if (watch("checkout_date") && !watch("checkout_time")) {
      setError("checkout_time", {
        message: "Checkout time required",
      });
    } else {
      clearErrors("checkout_time");
    }
  }, [watch("checkout_date"), watch("checkout_time")]);

  return (
    <div className="row-primary flex-column gap-0 mb-0">
      <h2 className="fst-italic">Add Check Out</h2>
      <div className="row-primary row-r">
        <div className="date">
          <h2>Date</h2>
          <Controller
            name="checkout_date"
            control={control}
            render={({ field }) => (
              <div style={{ width: "100%" }}>
                <div className="input-image">
                  <input
                    id="date"
                    type="date"
                    name="checkout_date"
                    placeholder="Date"
                    required
                    {...field}
                    value={
                      field.value
                        ? moment(field.value).format("YYYY-MM-DD")
                        : ""
                    }
                    onChange={(e) => {
                      if (e.target.value) {
                        const dateString = moment
                          .utc(e.target.value)
                          .format("YYYY-MM-DD");
                        field.onChange(dateString);

                        if (!dateString) {
                          setValue("checkout_time", "");
                        }
                      } else {
                        field.onChange("");
                        setValue("checkout_time", "");
                      }
                    }}
                  />
                  <img
                    src="/images/celender.png"
                    alt="celender Icon"
                    className="custom-icon"
                  />
                </div>
                {/* <div className="mt-2 sub_check">
                  <Checkbox
                    title={"Set Checkout Date"}
                    handleCheck={
                      (e) => {
                        if (e.target.checked) {
                          const currentDate = moment().format('YYYY-MM-DD')
                          setValue("checkout_date", currentDate)
                        }
                        else {
                          setValue("checkout_date", "")
                        }
                      }
                    }
                  />
                </div> */}
              </div>
            )}
          />
        </div>

        <div className="time">
          <h2>Time</h2>
          <Controller
            name="checkout_time"
            control={control}
            render={({ field }) => (
              <div style={{ width: "100%" }}>
                <div className="input-image">
                  <input
                    type="time"
                    name="checkout_time"
                    placeholder="hh:mm"
                    {...field}
                    // value={moment(field.value, ["h:mm A"]).format("HH:mm")}
                    // value={field.value}
                    required
                  />
                  <img
                    src="/images/clock.png"
                    alt="Clock Icon"
                    className="custom-icon"
                  />
                </div>

                {errors?.checkout_time?.message && (
                  <div style={{ margoutBottom: 10 }}>
                    <ErrorMessage text={errors?.checkout_time?.message} />
                  </div>
                )}
                {/* <div className="mt-2 sub_check">
                  <Checkbox
                    title={"Set Checkout Time"}
                    handleCheck={
                      (e) => {
                        if (e.target.checked) {
                          const currentTime = moment().add(15, 'minutes').format('HH:mm')
                          setValue("checkout_time", currentTime)
                        }
                        else {
                          setValue("checkout_time", "")
                        }
                      }
                    }
                  />
                </div> */}
              </div>
            )}
          />
        </div>
      </div>
    </div>
  );
};

export const CommentsAndNotes = () => {
  const { control, setValue, watch } = useFormContext();

  useEffect(() => {
    if (watch("interpreter_id"))
      setValue(
        "comments",
        commentsTypeOptions[commentsTypeOptions?.length - 1].value
      );
    else setValue("comments", "");
  }, [watch("interpreter_id")]);

  return (
    <>
      <div className="row-primary">
        <h2>Comments</h2>
        <Controller
          name="comments"
          control={control}
          render={({ field }) => (
            <Select
              name="comments"
              options={commentsTypeOptions || []}
              {...field}
              value={
                field.value
                  ? commentsTypeOptions?.find((opt) => field.value == opt.value)
                  : ""
              }
              onChange={field.onChange}
            />
          )}
        />
        {/* <p className="error">{field.error?.message}</p> */}
      </div>
      <div className="row-primary">
        <h2>Notes</h2>

        <Controller
          name="notes"
          control={control}
          render={({ field }) => (
            <textarea
              className="input-in type_inp"
              type="text"
              name="notes"
              placeholder="Enter notes and additional comments"
              {...control}
              {...field}
            />
          )}
        />
      </div>
    </>
  );
};

const durationOptions = [
  { label: "15 mins", value: 15 },
  { label: "30 mins", value: 30 },
  { label: "45 mins", value: 45 },
  { label: "1 hour", value: 60 },
  { label: "1 hour 15 mins", value: 75 },
  { label: "1 hour 30 mins", value: 90 },
  { label: "1 hour 45 mins", value: 105 },
  { label: "2 hours", value: 120 },
  { label: "2 hours 15 mins", value: 135 },
  { label: "2 hours 30 mins", value: 150 },
  { label: "2 hours 45 mins", value: 165 },
  { label: "3 hours", value: 180 },
  { label: "3 hours 15 mins", value: 195 },
  { label: "3 hours 30 mins", value: 210 },
  { label: "3 hours 45 mins", value: 225 },
  { label: "4 hours", value: 240 },
  { label: "4 hours 15 mins", value: 255 },
  { label: "4 hours 30 mins", value: 270 },
  { label: "4 hours 45 mins", value: 285 },
  { label: "5 hours", value: 300 },
  { label: "5 hours 15 mins", value: 315 },
  { label: "5 hours 30 mins", value: 330 },
  { label: "5 hours 45 mins", value: 345 },
  { label: "6 hours", value: 360 },
];

export const DurationRange = ({ control }) => {
  return (
    <div className="row-primary">
      <h2>Duration *</h2>
      <div className="w-100">
        <Controller
          name="duration"
          control={control}
          render={({ field }) => (
            <div style={{ width: "100%" }}>
              <Select
                options={durationOptions}
                value={durationOptions.find((opt) => opt.value === field.value) || null}
                onChange={(val) => field.onChange(val)}
              />
              <p style={{ fontSize: 12, color: "#6b7280", marginTop: 4 }}>
                Include Registration and Recovery time as applicable
              </p>
            </div>
          )}
        />
      </div>
    </div>
  );
};

const PriorityLevel = ({ control, errors }) => {
  return (
    <>
      <div className="row-primary">
        <h2>Priority Level</h2>
        <div className="radio_row">
          <Controller
            name="priority_level"
            control={control}
            // rules={{
            //   required: "Please select an Option"
            // }}
            render={({ field }) => {
              return priorityLevelOptions?.map((opt) => (
                <div className="form-check-f">
                  <input
                    className="form-check-input-f"
                    type="radio"
                    name={"priority_level"}
                    id={opt.value}
                    checked={field.value === opt.value}
                    value={opt.value}
                    onChange={(e) => field.onChange(e.target.value)}
                  // {...field}
                  />
                  <label className="form-check-label-f" htmlFor={opt.value}>
                    {opt.label}
                  </label>
                </div>
              ));
            }}
          />
        </div>
      </div>

      {errors?.facilities?.message && (
        <div className="mt-4">
          <ErrorMessage text={errors?.option?.message} />
        </div>
      )}
    </>
  );
};

const JobTypes = ({ control, errors }) => {
  return (
    <>
      <div className="row-primary">
        <h2>Job Type</h2>
        <div className="radio_row">
          <Controller
            name="job_type"
            control={control}
            render={({ field }) => {
              return jobTypesOptions?.map((opt) => (
                <div className="form-check-f">
                  <input
                    className="form-check-input-f"
                    type="radio"
                    name={"job_type"}
                    id={opt.value}
                    checked={field.value === opt.value}
                    value={opt.value}
                    onChange={(e) => field.onChange(e.target.value)}
                  />
                  <label className="form-check-label-f" htmlFor={opt.value}>
                    {opt.label}
                  </label>
                </div>
              ));
            }}
          />
        </div>
      </div>

      {errors?.facilities?.message && (
        <div className="mt-4">
          <ErrorMessage text={errors?.option?.message} />
        </div>
      )}
    </>
  );
};

export default ScheduleForm;
